// extracted by mini-css-extract-plugin
export default {"main":"_3p7xX","disabledPlus":"e_Nlw"};